// extracted by mini-css-extract-plugin
module.exports = {"div":"HomeDesktop_div_2OZu4"};